// AI generated component
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-information',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-lg-48 px-6">
                <span *ngIf="!seo.ignored && seo.fixed" translate>Good job! No issues were found</span>
                <span *ngIf="seo.ignored" translate>This issue is ignored</span>
                <mon-spinner [progress]="progress" *ngIf="!seo.ignored && !seo.fixed">
                    <!--High-->
                    <seo-information-duplicate-title [seo]="seo" *ngIf="seo.translation_name === 'seo_duplicate_title'"></seo-information-duplicate-title>
                    <seo-information-missing-h1 [seo]="seo" *ngIf="seo.translation_name === 'seo_missing_h1'"></seo-information-missing-h1>
                    <seo-information-missing-title [seo]="seo" *ngIf="seo.translation_name === 'seo_missing_title'"></seo-information-missing-title>

                    <!--Medium-->
                    <seo-information-duplicate-h1 [seo]="seo" *ngIf="seo.translation_name === 'seo_duplicate_h1'"></seo-information-duplicate-h1>
                    <seo-information-missing-alt [seo]="seo" [page]="page" *ngIf="seo.translation_name === 'seo_missing_alt'"></seo-information-missing-alt>
                    <seo-information-multiple-h1 [seo]="seo" *ngIf="seo.translation_name === 'seo_multiple_h1'"></seo-information-multiple-h1>
                    <seo-information-missing-subheadlines [seo]="seo" *ngIf="seo.translation_name === 'seo_missing_subheadlines'"></seo-information-missing-subheadlines>

                    <!--Low-->
                    <seo-information-missing-meta-description [seo]="seo" *ngIf="seo.translation_name === 'seo_missing_meta_description'"></seo-information-missing-meta-description>
                    <seo-information-too-long-meta-description [seo]="seo" *ngIf="seo.translation_name === 'seo_too_long_meta_description'"></seo-information-too-long-meta-description>
                    <seo-information-too-long-url [seo]="seo" *ngIf="seo.translation_name === 'seo_too_long_url'"></seo-information-too-long-url>
                    <seo-information-too-many-page-links [seo]="seo" *ngIf="seo.translation_name === 'seo_too_many_page_links'"></seo-information-too-many-page-links>
                    <seo-information-too-short-meta-description [seo]="seo" *ngIf="seo.translation_name === 'seo_too_short_meta_description'"></seo-information-too-short-meta-description>

                    <!-- Technical -->
                    <seo-information-no-follow [seo]="seo" *ngIf="seo.translation_name === 'seo_no_follow'"></seo-information-no-follow>
                    <seo-information-no-index [seo]="seo" *ngIf="seo.translation_name === 'seo_no_index'"></seo-information-no-index>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class SeoInformationInformationComponent {
    @Input() seo: any;
    @Input() page: any;
    @Input() progress: any;
}
